var moment = require('moment');
var momentFormats = ["YYYY-MM-DD", "DD-MM-YYYY"];
var mMnM = {
	0: ['sty', 'jan'],
	1: ['lut', 'feb'],
	2: ['mar', 'mar'],
	3: ['kwi', 'apr'],
	4: ['maj', 'may'],
	5: ['cze', 'jun'],
	6: ['lip', 'jul'],
	7: ['sie', 'aug'],
	8: ['wrz', 'sep'],
	9: ['paź', 'paz', 'oct'],
	10: ['lis', 'nov'],
	11: ['gru', 'dec']
}

function suggestNips(whole) {
	let nips = [];
	// let euroPatterns = [/(?:[Vv][Aa][Tt]|[Nn][Ii][Pp])(?:[A-z\s#№]*)?:?\s?(((ATU|CZ|FI|HU|LU|MT|SI)(\d{8}))|((BE0|BE1|BG|CZ|DE|EE|EL|LT|PT)(\d{9}))|((BG|CZ|PL|SK)(\d{10}))|((HR|LV|IT)(\d{11}))|((SE|LT)(\d{12}))|((NL)([a-zA-Z,*,+]{12}))|(CY(\d{8})[A-Za-z])|(IE((\d{7})WI)|(\d[a-zA-Z, +,*]\d{5})|((RO)(\d{2,10}))))/g,  /\D(\d{10})\D?/g]

	let patterns = [/(?:[Vv][Aa][Tt]|[Nn][Ii][Pp]|PL)(?:[A-z\s#№]*)?:?\s?[A-z]{0,2}(\d{10})\D?/g, /\D(\d{10})\D?/g];
	let text = whole
		.replace(/[-]/g, "")
		.replace(/(?<=\d) (?=\d)/g, "")
		.replace(/\s+/g, " ");
	regexNIP(text, patterns[0], nips)
	// console.log("suggestNips result 1 =>", nips);
	if (nips.length < 2) {
		regexNIP(text, patterns[1], nips)
		// console.log("suggestNips result 2 =>", nips);
	}
	return { nips: nips.map(x => x.nip), extra: getNipsByIndex(text, nips) }
}

function suggestInvoiceId(whole) {
	// let pattern = /(((nr|numer)\S?\s)|(faktur[ay]\s(vat\s)?((nr\S?\s)|(numer\S?\s))?(faktur[ay]\S?\s)?))(\S+)/gi;
	let text = whole
	// 	.replace(/\s+/g, " ");
	// let result = Array.from(text.matchAll(pattern));
	let patternPlnAngl = /(((((nr|number|numer|No|no)\S?\s)((invoice|faktur[ay]|invoice\s(vat\s)|faktur[ay]\s(vat\s))\S?\s))|(((invoice|faktur[ay]|invoice\s(vat\s)|faktur[ay]\s(vat\s))\S?\s)((nr|number|numer|No|no)\S?\s)))(?!(nr|number|numer|No|no)|((invoice|faktur[ay]|invoice\s(vat\s)|faktur[ay]\s(vat\s))\S?\s)))(\S+)/gi;
	let resultPlnAngl = Array.from(text.matchAll(patternPlnAngl));
	return resultPlnAngl.length ? resultPlnAngl[0].pop() : false;
}

function regexNIP(text, pattern, nips) {
	let regex = Array.from(text.matchAll(pattern));
	for (let i in regex) {
		let findIndex = nips.findIndex(x => x.nip == regex[i][1]);
		if (findIndex == -1) {
			nips.push({ nip: regex[i][1], index: regex[i].index });
		} else if (nips[findIndex].index < regex[i].index) {
			nips[findIndex].index = regex[i].index;
		}
	}
}

function getNipsByIndex(text, nips) {
	let nipCache = [...nips.sort((a, b) => a.index - b.index)]
	let patterns = [{ name: 'contractor', reg: /Sprzedawca/gi }, { name: 'main', reg: /Nabywca/gi }];
	let result = {}
	for (let pattern of patterns) {
		let regex = Array.from(text.matchAll(pattern.reg));
		if (regex.length) {
			let find = nipCache.find(x => x.index > regex[0].index);
			if (find) {
				result[pattern.name] = find.nip;
				nipCache.splice(nipCache.findIndex(x => x.nip == find.nip), 1)
			}
		}
	}
	// console.log('ALOOOOE', result, nips, nipCache);
	if (nips.length == 2 && Object.keys(result).length == 1) {
		if (result[patterns[0].name]) {
			result[patterns[1].name] = nips.find(x => x != result[patterns[0].name])['nip']
		} else {
			result[patterns[0].name] = nips.find(x => x != result[patterns[1].name])['nip']
		}
	}
	return Object.keys(result).length ? result : false
}

function suggestBankAccount(whole) {
	let text = whole
		.replace(/[-,:]/g, "")
		.replace("WBD", "0000")
		.replace(/(?<=\d) (?=\d)/g, "")
		.replace(/\s+/g, " ");
	let pattern = /[A-z]{0,2}(\d{26})\D/g;
	let result = Array.from(text.matchAll(pattern));
	// console.log("suggestBankAccount result =>", result.map(x => x[1]));
	return result.map(x => x[1])
}


function suggestDateRecept(whole) {
	let text = whole.replace(/\s+/g, " ");
	let pattern = /(wystawienia|issue|Invoice Date)\D{0,5}((\d{1,4})\D((\d{1,2})|sty|lut|mar|kwi|maj|cze|lip|sie|wrz|paź|paz|lis|gru|dec|nov|oct|sep|aug|jul|jun|may|apr|mar|feb|jan)\D\d{1,4})/gi

	let resultPattern = changeStrToIntDate(text.matchAll(pattern));
	let result = Array.from(resultPattern).map((x) => moment(x[1], momentFormats).format(momentFormats[0]));

	// console.log('suggestDateRecept result 1 =>', result);

	if (!result.length) {
		result = regexDate(text, false);
		return result
	}

	return result[0];
}

function suggestSaleDate(whole) {
	let text = whole.replace(/\s+/g, "");
	let pattern = /sprzedaży\D{0,5}(\d{1,4}\D\d{1,2}\D\d{1,4})/i;
	let result = text.match(pattern);
	return result ? moment(result[1], momentFormats).format(momentFormats[0]) : '';
}

function suggestDateSend(whole) {
	let text = whole.replace(/\s+/g, " ");
	let pattern = /wpływu\D{0,5}(\d{1,4}\D\d{1,2}\D\d{1,4})/i;
	let result = text.match(pattern);
	return result ? moment(result[1], momentFormats).format(momentFormats[0]) : '';
}

function suggestPaymentDate(whole) {
	let text = whole.replace(/\s+/g, " ");
	let pattern = /(Termin zapłaty|płatności|Due Date|Valid until)\D{0,5}((\d{1,4})\D((\d{1,2})|sty|lut|mar|kwi|maj|cze|lip|sie|wrz|paź|paz|lis|gru|dec|nov|oct|sep|aug|jul|jun|may|apr|mar|feb|jan)\D\d{1,4})/gi
	let resultPattern = changeStrToIntDate(text.matchAll(pattern));
	let result = Array.from(resultPattern).map((x) => moment(x[2], momentFormats).format(momentFormats[0]));

	// console.log("suggestPaymentDate result 1", result);
	if (!result.length) {
		result = regexDate(text, true);
		// console.log("suggestPaymentDate result 2", result);
		return result
	}
	return result[0];
}

function changeStrToIntDate(masRegexDate) {
	return Array.from(masRegexDate).map(x => {
		return x?.map( xx => {
			return xx?.replace(/sty|lut|mar|kwi|maj|cze|lip|sie|wrz|paź|paz|lis|gru/gi, (match) => {
				// console.log(match);
				let result
				for(let i in mMnM) {
					for(let j in mMnM[i]) {
						if (match == mMnM[i][j]) {
							result = i;
						}
					}
				}
				return result
			});
		})
	})
}


function regexDate(text, max) {
	let pattern = /\D((0[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)\d\d|[0-9]{4}-(0[1-9]|1[012])-(0[1-9]|1[0-9]|2[0-9]|3[01]))\D/g;
	let result = Array.from(text.matchAll(pattern)).map((x) => moment(x[1], momentFormats).format(momentFormats[0]));
	if (result.length > 1) {
		if (max) {
			result = result.reduce((a, b) =>
				moment(a).isAfter(b) ? a : b
			);
		} else {
			result = result.reduce((a, b) =>
				moment(a).isBefore(b) ? a : b
			);
		}
		return result
	}
	return result[0]
}

function suggestCurrency(text) {
	let currency = [
		{
			symbols: ['zł', 'PLN'],
			name: "PLN"
		},
		{
			symbols: ['€', 'EUR'],
			name: "EUR"
		},

		{
			symbols: ['$', 'USD'],
			name: "USD"
		}
	];
	for (let i of currency) {
		for (let j of i.symbols) {
			if (text.indexOf(j) != -1) {
				return i.name
			}
		}
	}
	return ''
}

function suggestPaymentType(text) {
	text = text.toLowerCase()
	let variabls = ['barter', 'kompensata', 'pobranie', 'karta', 'przelew', 'gotówka', 'Płatność przez Pracownika']
	for (let i of variabls) {
		if (text.indexOf(i) != -1 || text.indexOf() != -1) {
			return i
		}
	}
	return ''
}

export { suggestPaymentDate, suggestSaleDate, suggestDateRecept, suggestDateSend, suggestCurrency, suggestPaymentType, suggestBankAccount, suggestNips, suggestInvoiceId };
